"use client"

import Pipeline from "@/components/pipeline/Pipeline"

export default function DashboardPage() {
  return <Pipeline />
}